/**
 * Checks if the application is running on localhost
 * @returns true if running on localhost, false otherwise
 */
export function isLocalhost(): boolean {
	if (typeof window === "undefined") {
		return false;
	}

	const hostname = window.location.hostname;
	return (
		hostname === "localhost" ||
		hostname === "127.0.0.1" ||
		hostname === "[::1]" || // IPv6 localhost
		hostname.startsWith("192.168.") || // Local network IP
		hostname.startsWith("10.") || // Local network IP
		hostname.startsWith("172.") // Local network IP (172.16.0.0 - 172.31.255.255)
	);
}
